module.exports = __webpack_public_path__ + "static/media/icon-wb_moon.11129024.svg";